module.exports = __webpack_public_path__ + "static/coffeetalk3-e28799fdb9da672bd8e88e05da54e6af.png";